var utils = require("./utils");

exports.set = function(key, value) {
	var ctx = utils.ensureCtx();
	var web = ctx.get_web();
	var propBag = web.get_allProperties();
	propBag.set_item(key, value + "");
	ctx.load(web);
	ctx.load(propBag);
	web.update();

	return utils.executeBatch(ctx)
		.then(() => console.log("Success - Set " + key + " to " + value))
        .catch(() => console.log("Failed to set " + key + " property"))
};

exports.get = function(key) {
	// look at the property bag of the current spweb
	ctx = ctx || SP.ClientContext.get_current();
    var web = ctx.get_web();
    var propBag =  web.get_allProperties();

    ctx.load(web);
    ctx.load(propBag);

    return utils.executeBatch(ctx).then(() => {
        var props = propBag.get_fieldValues()
        if (key) return props[key];
        return props;
    });
};


// WEBPACK FOOTER //
// ./src/scripts/jsom/webProperties.js